module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"failedToFetch":"Failed to search for orders"},"no":{"failedToFetch":"Kunne ikke søke etter ordre"}}')
  delete Component.options._Ctor
}
